<template lang="pug">
.loginOperation(v-show='showPage')
  .loginpanel(v-show='!showRechargeCardStep')
    //- 滑块验证
    slideCheck.slideCheck(
      v-if='!ist2s',
      v-show='slideCheck',
      ref='slideCheck',
      :class='{ jfstyle: clientType }',
      :errText='errText',
      @check='slideCheckCB',
      @close='initSlideCheck'
    )
    //- 身份选择
    ul.identityTab(v-if='identityList.length && !clientType')
      li(
        v-for='(item, index) in identityList',
        :class='{ active: identity === item, [item]: true }',
        @click='changeIdentity(item)'
      ) {{ $t(`Login.loginBody.${identitystr}[${index}]`) }}
    //- 错误提示
    .error-tip(v-if='!clientType', :style='{ opacity: errorText ? 1 : 0 }')
      div
        span.error-tip-text {{ errorText }}
        span.error-tip-text.red(
          @click='toggleFindPwd',
          v-show='identity ===\'student\' && isShow'
        ) 忘记密码
    //- 用户名
    .username
      km-input(
        ref='input_unsername',
        v-model='username',
        placeholder='请输入账号或手机号',
        :autofocus='true',
        @enter='handleLogin',
        @change='clearErrorText'
      )
        i.icon.icon_username(slot='icon')
    //- 密码
    .password
      km-input(
        ref='input_password',
        autocomplete='new-password',
        v-model='password',
        style='margin-top: 20px',
        type='password',
        placeholder='请输入密码',
        @enter='handleLogin',
        @input='clearErrorText'
      )
        i.icon.icon_password(slot='icon')
    .ext-info()
      p(v-if='identity === "teacher" && !clientType' style="margin: 10px 0;")
        | 申请账号，请联系
        span(@click='callOnlineService') 在线客服
          template(v-if='identity === "student"')
      .recharge-card-entry(v-if='identity === "student"' @click='handleRechargeCardLogin') 充值卡登录

      //- p(style='font-size: 12px')
      //-   | 登录即同意
      //-   span(style='font-size: 12px', @click='handleAgreement') 《用户服务协议》
      //-   span(style='font-size: 12px; color: #666') 和
      //-   span(style='font-size: 12px', @click='handlePrivacy') 《隐私政策》
      div(
        :class='{ m30: identity !== "student" && identity !== "teacher", operation: identity === "student" }'
      )
        span(@click='toggleFindPwd', v-show='showFindPasswordBtn' style="cursor: pointer") {{ $t('Login.loginBody.forgetPass') }}？
    .submit
      button(@click='handleLogin') {{ $t('Login.loginBody.login') }}
    .ext-info(v-if='!clientType' style="padding-bottom: 60px;")
      p
        | 登录即同意
        span(style='font-size: 12px', @click='handleAgreement') 《用户服务协议》
        span(style='font-size: 12px; color: #666') 和
        span(style='font-size: 12px', @click='handlePrivacy') 《隐私政策》
    //- .ext-info(v-if='identity === "teacher" && !clientType')
    //-   p
    //-     | 申请账号，请联系
    //-     span(@click='callOnlineService') 在线客服
    .other_operation.flex-center-center(v-if='!clientType')
      i.icon
      span(@click='downloadAppByCode') {{ $t('Login.loginBody.downloadQR') }}
      span(
        v-if='!checkIsZhaoyang',
        v-show='identity===\'student\' && allowRegister',
        @click='gotoRegister'
      ) {{ $t('Login.loginBody.register') }}
    //- 错误提示
    .error-tip(v-if='clientType', :style='{ opacity: errorText ? 1 : 0 }')
      div
        span.error-tip-text {{ errorText }}
        span.error-tip-text.red(
          @click='toggleFindPwd',
          v-show='identity ===\'student\' && isShow'
        ) 忘记密码
  //- 二维码
  .qrCode(
    v-if='!clientType',
    :class='{ enter: showqrCode, leave: !showqrCode }',
    @mouseover='overShow',
    @mouseout='overHide'
  )
    img.studentApp(:src='stuQrcode')
    p.mobile {{ $t('Login.loginBody.studentMobile') }}
    img.teacherApp(:src='teaQrcode')
    p.mobile {{ $t('Login.loginBody.teacherMobile') }}
  //- 充值卡登录
  .loginpanel(v-if='showRechargeCardStep')
    RechargeCard(
      :onBack='handleRechargeCardBack',
      @loginSuccess='handleRechargeCardLoginSuccess',
      @bindComplete='handleRechargeCardBindComplete',
      @forgotPassword='handleRechargeCardForgotPassword'
    )
  //- 学生姓名实名校验
  .verify-name-mask(v-if='showVerifyNameDialog')
    .verify-name-dialog
      i.verify-name-close(@click='closeVerifyNameDialog') ×
      .verify-name-icon
      h3 请验证姓名
      p 请输入您在学校登记的姓名，用于确认账号身份
      .verify-name-input(:class='{ error: verifyNameError }')
        i.icon.icon_username
        input(
          ref='verifyNameInput',
          v-model='verifyName',
          placeholder='请输入姓名',
          @keyup.enter='submitVerifyName',
          @input='clearVerifyNameError'
        )
      .verify-name-error(:style='{ opacity: verifyNameError ? 1 : 0 }') {{ verifyNameError || '占位' }}
      button.verify-name-submit(@click='submitVerifyName') 确认
      .verify-name-cancel(@click='closeVerifyNameDialog') 取消并返回登录
      .verify-name-tips
        .verify-name-tip
          span.tip-icon.safe
          span
            | 频繁出现姓名验证？建议
            span.verify-name-link(@click='handleVerifyNameFindPwd') 修改密码
            | ，保护账号安全
        .verify-name-tip
          span.tip-icon.phone
          span
            | 姓名不一致？请联系班级老师或
            span.verify-name-link(@click='handleVerifyNameOnlineService') 在线客服
            | 协助处理
</template>

<script>
import {
  readToken,
  unifyLogin,
  preLogin,
  tpreLogin,
  hpreLogin,
  confirgue,
  getNeedAfsAuth,
  epaasUserLogin,
  checkLogin,
  loginConfig,
} from '@/api'
import { $cookie, trim, getBrowserInfo } from '@/util/Util'
import slideCheck from './slideCheck'
import RechargeCard from './RechargeCard'
import cryptoJs from 'crypto-js'
import Utf8 from 'crypto-js/enc-utf8'
const passwordKey = cryptoJs.MD5('password').toString()

const key = Utf8.parse('0n1jcAGW3UgyOB7XorYLyauj')
const iv = Utf8.parse('41yBvl7Thdo2Z0qN')
function aesEncrypt(text) {
  // 密钥和偏移量需转为 CryptoJS 格式（Utf8 编码）
  const keyUtf8 = cryptoJs.enc.Utf8.parse(key)
  const ivUtf8 = cryptoJs.enc.Utf8.parse(iv)

  // 加密：参数依次为 明文、密钥、配置项（模式、偏移量、填充）
  const encrypted = cryptoJs.AES.encrypt(text, keyUtf8, {
    iv: ivUtf8,
    mode: cryptoJs.mode.CBC, // CBC 模式
    padding: cryptoJs.pad.Pkcs7, // 默认填充方式，可省略
  })
  // 加密结果转为 Base64 字符串（常用）或 Hex 字符串
  return encrypted.ciphertext.toString(cryptoJs.enc.Base64)
  // return encrypted.ciphertext.toString(CryptoJS.enc.Hex); // Hex 格式
}
function aesDecrypt(ciphertext) {
  const keyUtf8 = cryptoJs.enc.Utf8.parse(key)
  const ivUtf8 = cryptoJs.enc.Utf8.parse(iv)

  // 先将 Base64/Hex 格式的密文转回 cryptoJs 格式
  const ciphertextUtf8 = cryptoJs.enc.Base64.parse(ciphertext)
  // const ciphertextUtf8 = cryptoJs.enc.Hex.parse(ciphertext); // Hex 格式

  // 解密
  const decrypted = cryptoJs.AES.decrypt(
    { ciphertext: ciphertextUtf8 }, // 密文对象
    keyUtf8,
    { iv: ivUtf8, mode: cryptoJs.mode.CBC, padding: cryptoJs.pad.Pkcs7 }
  )

  // 解密结果转为 UTF-8 字符串
  return decrypted.toString(cryptoJs.enc.Utf8)
}
export default {
  name: 'Form',
  props: ['toggleFindPwd', 'ist2s', 'clientType'],
  components: {
    slideCheck,
    RechargeCard
  },
  computed: {
    showFindPasswordBtn() {
      return this.identity === 'student' || this.identity === 'teacher'
    },
    showPage() {
      return !(this.urlParams.token || this.urlParams.appid || this.urlParams.uid)
    },
  },
  data() {
    return {
      checkIsZhaoyang: window.ConfigNew.checkIsZhaoyang, // 朝阳去隐藏二维码
      urlParams: this.getUrlParam(),
      identityList: ['student', 'teacher', 'parent', 'headmaster'],
      identity: 'student',
      errorText: '',
      showqrCode: false,
      username: '',
      password: '',
      clearSetTimeout: '',
      stuQrcode: '',
      teaQrcode: '',
      identitystr: this.ist2s ? 'tidentity' : 'identity',
      allowRegister: false,
      isShow: false,
      errText: '',
      slideCheck: true, // 滑块验证
      slideCheckCB: () => { },
      // 充值卡登录相关
      showRechargeCardStep: false,
      showVerifyNameDialog: false,
      verifyName: '',
      verifyNameError: '',
      pendingLoginInfo: null,
      isVerifyNameRequired: false,
      servicePhone: '400-018-9011'
    }
  },
  watch: {
    identity: {
      immediate: true,
      handler(v) {
        this.$emit('identity', v)
      }
    }
  },
  methods: {
    // handleDelete() {
    //   if (this.useRemberPassword) {
    //     this.password = ''
    //   }
    // },
    handlePrivacy() {
      window.open('/static/page/private.html', '_blank')
    },
    handleAgreement() {
      window.open('/web/statics/qsnxy-kami.html', '_blank')
    },
    callOnlineService() {
      document.querySelector('.onlineService.sidebarSection').click()
    },
    handleVerifyNameFindPwd() {
      this.closeVerifyNameDialog()
      this.toggleFindPwd()
    },
    handleVerifyNameOnlineService() {
      this.callOnlineService()
    },
    getUrlParam() {
      let urlP = {}
      if (location.search) {
        location.search
          .substring(1)
          .split('&')
          .forEach((item) => {
            let _kv = item.split('=')
            urlP[_kv[0]] = _kv[1]
          })
      }
      return urlP
    },
    changeIdentity(type) {
      // 切换身份
      this.identity = type
      // if (type !== 'student' && this.errorText === '您输入的密码和账户名不匹配,是否') {
      //   this.errorText = '您输入的密码和账户名不匹配!'
      // }
    },
    handleTeaMenu(menu) {
      if (menu) {
        let arr = []
        menu.forEach((item) => {
          arr.push({
            tag_action: item.tag_action,
            module: item.module,
            url: item.url,
            name: item.name,
          })
        })
        $cookie.set('teaMenu', JSON.stringify(arr))
      }
    },
    doPreLogin(cb) {
      let { username, identity } = this
      let ploginFn =
        identity === 'headmaster'
          ? hpreLogin
          : identity === 'teacher'
            ? tpreLogin
            : preLogin
      username = trim(username)

      ploginFn({
        username,
      }).then((res) => {
        if (res.status === 1) {
          let data = res.data.CustomerInfo

          $cookie.set('hasZy', data.only_zy) // 仅作业
          $cookie.set('hasCp', data.only_cp) // 仅测评
          $cookie.set('model', data.to_b) // 1:2B else:2C 配置

          localStorage.setItem('cpUrl', data.cp_url)
          localStorage.setItem('zyUrl', data.zy_url)
          localStorage.setItem('mUrl', data.mobile_url)
          localStorage.setItem('accUrl', data.acc_url)
          localStorage.setItem('resUrl', data.resource_url + '/')
          localStorage.setItem('gatewayUrl', data.gatewayUrl)

          typeof cb === 'function' && cb()
        } else {
          this.isShow = false
          this.errorText = res.info

          if (this.urlParams.token) {
            alert(this.errorText)
          }
        }
      })
    },
    initSlideCheck() {
      this.slideCheck = false
      this.slideCheckCB = () => { }
      this.$refs.slideCheck && this.$refs.slideCheck.reset()
    },
    doLogin(isMd5, nv, extraParams) {
      let { identity, username, password } = this
      username = trim(username)

      return unifyLogin(
        Object.assign(
          {
            identity,
            username,
            password:
              isMd5 === '1' ? trim(password) : cryptoJs.MD5(trim(password)).toString(),
          },
          extraParams || {},
          nv
            ? {
              nv: nv.data,
            }
            : {}
        )
      ).then(async (res) => {
        if (res.status === 1) {
          this.showVerifyNameDialog = false
          this.verifyNameError = ''
          if (nv && nv.call) {
            nv.call()
          }
          localStorage.removeItem('stu_index_region') // 删除学生端听说考试、专项训练 地区保存的配置
          localStorage.removeItem('stu_index_grade') // 删除学生端听说考试、专项训练 地区保存的配置
          localStorage.setItem(
            'socketToken',
            new Date().getTime() + Math.random().toFixed(10)
          ) // websocket token
          $cookie.set('identity', identity)
          if (this.urlParams.token) {
            $cookie.set('token', this.urlParams.token)
          } else {
            $cookie.set('username', username)
            if (isMd5 === '1') {
              localStorage.removeItem(passwordKey)
            } else {
              localStorage.setItem(passwordKey, aesEncrypt(password))
            }
          }
          localStorage.setItem('isShowCorrectDialog', true)
          // 电教馆 评价举报用id
          localStorage.setItem(
            'djg-id',
            (identity === 'headmaster' ? 'mas' : identity.substring(0, 3)) + res.data.id
          )
          if (identity === 'parent') {
            $cookie.set('stuId', res.data.student_id)
          } else {
            $cookie.set('stuId', '')
          }
          this.$store.username = username
          this.$store.password = password

          const { location } = window
          const { protocol, origin, hostname } = location
          const info = res.data
          const { relate_client, url } = info
          let _origin = origin
          let _host = 'kami' // 客户名称，例如：kami、jimei

          this.handleTeaMenu(info.menu)

          if (
            identity === 'student' &&
            this.isVerifyNameRequired &&
            this.isDefaultPasswordLogin(info)
          ) {
            this.initSlideCheck()
            await this.showDefaultPasswordDialog()
            return
          }

          if (
            relate_client &&
            window.ConfigNew.doubleBrandWhiteList.indexOf(relate_client) > -1
          ) {
            _host = relate_client
            if (hostname.indexOf(relate_client) < 0) {
              // url中不包含客户
              const splitList = hostname.split('.')
              if (splitList.length < 3) {
                // 防止类似 http(s)://kamienglish.com 的域名
                splitList.unshift(relate_client)
              } else {
                splitList[0] = relate_client
              }
              _origin = protocol + '//' + splitList.join('.')
            }
          }

          $cookie.set('origin', _origin) // 用于测评系统返回二级域名（如果有）的作业系统
          $cookie.set('host', _host) // 用于测评系统获取二级logo（如果有）

          const browser = getBrowserInfo()
          const track = {
            accessToken: info.accessToken,
            customerInfoId: info.customerInfoId,
            userRoleType: info.user_role_type,
            clientVersion: info.clientVersion,
            serverVersion: info.serverVersion,
            userId: info.id,
            userName: username,
            fullName: encodeURIComponent(info.teacher_name || info.name),
            schoolId: info.school_id,
            categoryId: info.category_id,
            scId: info.school_class_id,
            actionOrigin: 1, // 动作来源 1.作业系统 2.测评系统 3内容系统 4.前端
            clientType: 1, // 客户端类型 0.未传或未知 1.Web 2.IOS 3.Android
            clientInfo: browser.name + ' ' + browser.version,
            loginFrom: 1,
            logType: 1, // 日期类型 1正常日志 0异常日志
          }

          localStorage.setItem('kami_track', JSON.stringify(track))
          // 判断是否来自教研平台
          if (this.ist2s) {
            localStorage.setItem('t2s', true)
          } else {
            localStorage.removeItem('t2s')
          }
          const status = +res.data.status
          // 未完善信息的学生
          if (status === 2) {
            this.initSlideCheck()
            this.$emit('perfectInfo', {
              type: 'perfectInfo',
              isPer: +res.data.regFrom === 7,
            })
            return
          }
          // 未激活激活码
          if (status === 4) {
            this.initSlideCheck()
            this.$emit('next', res.data.username)
            return
          }
          // 被踢出班级的学生
          if (status === 5) {
            this.initSlideCheck()
            this.$emit('perfectInfo', {
              type: 'removeClass',
              isPer: +res.data.regFrom === 7,
            })
            return
          }
          // 自由注册没有班级的提示一下
          if (status === 6) {
            await this.$confirm(
              '温馨小提示',
              '<div style="text-align:left; width: 320px">Hi~同学，欢迎使用“驰声听说在线”，建议登录老师提供的账号，否则自己注册的账号是没有班级、无法正常接收老师布置的练习的，如果您还没收到老师发放的账号，请向老师咨询～<div>',
              {
                useHtml: true,
                showCancelButton: false,
                confirmTxt: '知道了',
                distinguishCancelAndClose: true,
              }
            )
          }

          let href = ''
          if (this.urlParams.redirect) {
            let redirect = decodeURIComponent(this.urlParams.redirect)
            redirect = redirect[0] === '/' ? redirect : '/' + redirect
            href = _origin + redirect
          } else if (identity === 'student') {
            href = _origin + '/stu'
          } else if (identity === 'teacher') {
            href = _origin + '/teacher'
          } else {
            href = _origin + '/web/' + url
          }
          location.href = href
        } else {
          this.initSlideCheck()
          if (extraParams && extraParams.verifyName) {
            this.verifyNameError = res.info || '姓名校验失败，请核对后重试'
            this.$nextTick(() => {
              this.$refs.verifyNameInput && this.$refs.verifyNameInput.focus()
            })
            return
          }
          this.errorText = res.info
          this.isShow = true
          console.log(this.urlParams.token)
          if (this.identity === 'student' && this.isShow) {
            this.errorText = '您输入的密码和账户名不匹配,是否'
          }
          if (this.urlParams.token) {
            alert(this.errorText.substr(0, this.errorText.length - 3))
          }
        }
      })
    },
    handleLogin(isMd5) {
      this.handleLoginAsync(isMd5).catch(() => { })
    },
    async handleLoginAsync(isMd5) {
      let { username, password, identity } = this
      username = trim(username)
      password = trim(password)

      if (!username && !password) {
        this.isShow = false
        this.errorText = '账户名和密码都不能为空!'
      } else if (!username) {
        this.isShow = false
        this.errorText = '账户名不能为空!'
      } else if (!password) {
        this.isShow = false
        this.errorText = '密码不能为空!'
      } else if (this.urlParams.token || this.urlParams.appid) {
        this.doLogin(isMd5)
      } else {
        this.errorText = ''
        // this.doPreLogin(this.doLogin)
        if (identity === 'student') {
          const res = await checkLogin({
            username,
            password:
              isMd5 === '1' ? trim(password) : cryptoJs.MD5(trim(password)).toString(),
          })
          if (res.status === 4302) {
            await this.$confirm(
              '登录确认',
              `<div style="text-align:left; width: 320px">您的账号已在其他设备登录中。该登录设备是${res.data.login.mobileModel}。确认登录，已登录设备会强制退出登录。是否继续登录？<div>`,
              {
                useHtml: true,
                confirmTxt: '继续登录',
                cancelTxt: '取消',
                closeOnClickModal: false,
                showClose: false,
                distinguishCancelAndClose: true,
              }
            )
          }
        }
        // 检查是否需要滑块验证
        getNeedAfsAuth({
          identity,
          username,
        }).then((res_) => {
          if (res_.status === 1) {
            this.pendingLoginInfo = {
              isMd5: isMd5,
              needAfsAuth: res_.data.needAfsAuth,
              msg: res_.data.msg,
              nv: null
            }
            this.isVerifyNameRequired = +res_.data.isVerifyName === 1
            if (res_.data.needAfsAuth) {
              this.openAfsAuth()
            } else if (this.isVerifyNameRequired) {
              this.openVerifyNameDialog()
            } else {
              this.continueLoginAfterVerifyName('')
            }
          } else {
            this.errorText = res_.info
          }
        })
      }
      if (this.urlParams.token && this.errorText) {
        alert(this.errorText.substr(0, this.errorText.length - 3))
      }
    },
    downloadAppByCode() {
      this.showqrCode = !this.showqrCode
      this.clearSetTimeout = window.setTimeout(() => {
        window.clearTimeout(this.clearSetTimeout)
        if (this.showqrCode) {
          this.showqrCode = !this.showqrCode
        }
      }, 5000)
    },
    gotoRegister() {
      this.$emit('showRegister')
    },
    overShow() {
      this.showqrCode = true
      window.clearTimeout(this.clearSetTimeout)
    },
    overHide() {
      this.showqrCode = false
      window.clearTimeout(this.clearSetTimeout)
    },
    clearErrorText() {
      this.errorText = ''
    },
    clearVerifyNameError() {
      this.verifyNameError = ''
    },
    openVerifyNameDialog() {
      this.verifyName = ''
      this.verifyNameError = ''
      this.initSlideCheck()
      this.showVerifyNameDialog = true
      this.$nextTick(() => {
        this.$refs.verifyNameInput && this.$refs.verifyNameInput.focus()
      })
    },
    closeVerifyNameDialog() {
      this.showVerifyNameDialog = false
      this.verifyName = ''
      this.verifyNameError = ''
      this.pendingLoginInfo = null
      this.isVerifyNameRequired = false
      this.initSlideCheck()
    },
    submitVerifyName() {
      const verifyName = trim(this.verifyName)
      if (!verifyName) {
        this.verifyNameError = '请输入姓名'
        return
      }
      this.continueLoginAfterVerifyName(verifyName)
    },
    openAfsAuth() {
      const pending = this.pendingLoginInfo || {}
      this.errText = pending.msg
      this.slideCheck = true
      this.slideCheckCB = (obj) => {
        if (typeof obj === 'object') {
          this.pendingLoginInfo = Object.assign({}, pending, {
            nv: obj
          })
          if (this.isVerifyNameRequired) {
            this.openVerifyNameDialog()
          } else {
            this.doLogin(pending.isMd5, obj)
          }
        } else {
          this.initSlideCheck()
          this.$confirm('提示', '网络连接不稳定，请刷新后再试一下！', {
            confirmTxt: '重新刷新',
            cancelTxt: '关闭',
          }).then(() => {
            window.location.reload()
          })
        }
      }
    },
    continueLoginAfterVerifyName(verifyName) {
      const pending = this.pendingLoginInfo || {}
      const extraParams = verifyName
        ? {
          verifyName: verifyName
        }
        : {}

      this.doLogin(pending.isMd5, pending.nv, extraParams)
    },
    isDefaultPasswordLogin(info) {
      const flagList = [
        info.isDefaultPassword,
        info.is_default_password,
        info.defaultPassword,
        info.needChangePassword,
        info.isNeedModifyPassword,
        info.forceModifyPassword,
        info.is_default_pwd
      ]
      return flagList.some(item => item === true || item === 1 || item === '1')
    },
    showDefaultPasswordDialog() {
      return this.$confirm(
        '温馨提示',
        '<div style="text-align:left; width: 320px">您的账号当前仍在使用默认密码，为保护账号安全，请先修改密码后再登录。<br/><br/>如果您不清楚如何处理，请联系<span style="color:#333">班级老师</span>或电话客服。</div>',
        {
          useHtml: true,
          confirmTxt: '修改密码',
          cancelTxt: '电话客服',
          closeOnClickModal: false,
          showClose: false,
          distinguishCancelAndClose: true
        }
      ).then(() => {
        this.toggleFindPwd()
      }).catch(() => {
        window.location.href = 'tel:' + this.servicePhone
      })
    },
    getInfoByToken(params) {
      // 一键登录用
      readToken(params).then((res) => {
        if (res.status === 1) {
          this.username = res.data.numberId
          this.password = res.data.password
          this.handleLogin('1')
        } else {
          alert(res.info)
        }
      })
    },
    getInfoByCode() {
      epaasUserLogin({
        appid: this.urlParams.appid,
        code: this.urlParams.code,
      }).then((res) => {
        if (res.status === 1) {
          this.username = res.data.username
          this.password = res.data.password
          this.identity = this.identityList.includes(res.data.identity)
            ? res.data.identity
            : 'student'
          this.handleLogin('1')
        } else {
          alert(res.info)
        }
      })
    },
    handleRechargeCardLogin() {
      this.showRechargeCardStep = true
    },
    handleRechargeCardBack() {
      this.showRechargeCardStep = false
    },
    handleRechargeCardLoginSuccess(data) {
      this.username = data.username
      this.password = data.password
      this.identity = 'student'
      this.doLogin('1')
    },
    handleRechargeCardBindComplete(data) {
      this.showRechargeCardStep = false
      this.$message.success('绑定成功')
      if (data && data.username && data.password) {
        this.handleRechargeCardLoginSuccess(data)
      }
    },
    handleRechargeCardForgotPassword() {
      this.showRechargeCardStep = false
      this.$emit('toggleFindPwd')
    }
  },
  created() {
    // 兼容老的存储方式
    const _password = $cookie.get('password')
    if (_password) {
      localStorage.setItem(passwordKey, aesEncrypt(_password))
      $cookie.set('password', '', -1)
    }
    if (this.ist2s) {
      this.identityList.length = 2
    }
    if (this.urlParams.code && this.urlParams.appid) {
      this.getInfoByCode()
    } else if (this.urlParams.key && this.urlParams.uid) {
      const identity = this.urlParams.identity
      this.identity = this.identityList.includes(identity) ? identity : 'student'
      this.getInfoByToken(this.urlParams)
    } else if (this.urlParams.token || this.urlParams.usb) {
      const identity = this.urlParams.identity
      this.identity = this.identityList.includes(identity) ? identity : 'student'
      const params = this.urlParams.usb
        ? {
          usb: this.urlParams.usb,
        }
        : {
          token: this.urlParams.token,
        }
      this.getInfoByToken(params)
    } else if (this.clientType === 'teacher') {
      this.identity = 'teacher'
    } else if (this.clientType === 'student') {
      // 机房和客户端
      this.identity = 'student'
      const username = $cookie.get('username') || ''
      if (username) {
        loginConfig({ username }).then((res) => {
          if (res.status === 1 && res.data.rememberPass) {
            this.username = username
            const password = localStorage.getItem(passwordKey)
            if (password) {
              this.password = aesDecrypt(password)
            } else {
              this.password = ''
            }
            // setTimeout(() => {
            //   this.useRemberPassword = true
            // }, 300)
          }
        })
      }
    } else if (!this.clientType) {
      const identity = $cookie.get('identity')
      this.identity = this.identityList.includes(identity) ? identity : 'student'
      this.username = $cookie.get('username') || ''
      const password = localStorage.getItem(passwordKey)
      if (password) {
        this.password = aesDecrypt(password)
      } else {
        this.password = ''
      }
      // setTimeout(() => {
      //   this.useRemberPassword = true
      // }, 300)
    }
  },
  mounted() {
    this.initSlideCheck()

    console.log(this.urlParams)
    this.$store.login = (username, password) => {
      if (username && password) {
        this.username = username
        this.password = password
      }
      this.handleLogin()
    }
    confirgue().then((res) => {
      this.allowRegister = res.data.passport.allowRegister
    })
    this.downloadAppByCode() // 显示二维码

    // 二维码
    const { customer } = window.ConfigNew
    this.stuQrcode = `https://download.chivoxapp.com/assets/${customer}/qr-stu.png`
    this.teaQrcode = `https://download.chivoxapp.com/assets/${customer}/qr-tea.png`
  },
}
</script>

<style lang="less" scoped>
@import url('./Form.less');

.m30 {
  position: relative;
  text-align: right;
  margin-top: 39px !important;
}

.ext-info {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    line-height: 20px;
    margin: 10px auto;
    text-align: center;
    font-size: 12px;

    span {
      color: #21bd73;
      cursor: pointer;
    }
  }
}

.loginpanel {
  position: relative;
}

.slideCheck {
  position: absolute;
  top: 0;
  right: 0;
  width: 360px !important;
  height: 340px !important;
  z-index: 10;

  &.jfstyle {
    top: -30px;
    left: 0;
    right: 0;
    width: 600px !important;
    height: 400px !important;
  }
}

.verify-name-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10020;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
}

.verify-name-dialog {
  position: relative;
  width: 360px;
  height: 465px;
  padding: 28px 20px 26px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.14);
  text-align: center;

  h3 {
    margin: 12px 0 12px;
    color: #333;
    font-size: 18px;
    font-weight: 600;
  }

  p {
    width: 100%;
    margin: 0 auto 16px;
    color: #999;
    font-size: 12px;
    line-height: 17px;
  }
}

.verify-name-close {
  position: absolute;
  top: 9px;
  right: 14px;
  color: #aeb4bd;
  font-size: 24px;
  font-style: normal;
  line-height: 24px;
  cursor: pointer;
}

.verify-name-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto;
  background: url('../../../assets/images/icon_verify_name.png') no-repeat center;
  background-size: contain;
}

.verify-name-input {
  display: flex;
  align-items: center;
  width: 100%;
  height: 36px;
  margin: 0 auto;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;

  &.error {
    border-color: #ff7777;
    background: #fff5f5;
  }

  .icon {
    width: 20px;
    height: 20px;
    margin: 0 10px;
    background: url('/static/images/login/icon_login.png') 0 -1px;
  }

  input {
    flex: 1;
    height: 34px;
    padding: 0;
    border: none;
    outline: none;
    color: #666;
    font-size: 14px;
    background: transparent;
  }
}

.verify-name-error {
  width: 100%;
  min-height: 22px;
  margin: 10px auto 0;
  color: #ff6666;
  font-size: 12px;
  line-height: 17px;
  text-align: left;
}

.verify-name-submit {
  width: 100%;
  height: 34px;
  margin-top: 20px;
  border: none;
  border-radius: 17px;
  outline: none;
  background: #24cc7c;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.verify-name-cancel {
  margin: 12px 0 23px;
  color: #666;
  font-size: 13px;
  cursor: pointer;
}

.verify-name-tips {
  width: 100%;
  margin: 0 auto;
  padding-top: 20px;
  border-top: 1px dashed #e5e5e5;
}

.verify-name-tip {
  display: flex;
  align-items: center;
  margin-top: 12px;
  color: #666;
  font-size: 12px;
  line-height: 17px;
  text-align: left;

  span {
    font-size: 12px;
  }

  &:first-child {
    margin-top: 0;
  }

  .tip-icon {
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    margin-right: 8px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    &.safe {
      background-image: url('../../../assets/images/icon_verify_safe.png');
    }

    &.phone {
      background-image: url('../../../assets/images/icon_verify_service.png');
    }
  }
}

.verify-name-link {
  color: #21BD73;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/login/components/Form.vue